<template>
  <div class="registration-container">
    <rich-registration-header :step="actualSection.id">
      <template slot="title">{{ actualSection.title }}</template>
    </rich-registration-header>
    <h1 class="section-container uni-display-2 main-title">Création d'un compte pour l'inscription</h1>
    <h2 v-if="actualSection.id !== 1" class="section-subtitle section-container uni-display-3">{{
        actualSection.title
      }}</h2>
    <div class="main">
      <section class="section-container" v-show="actualSection.name === 'email'">
        <ValidationObserver ref="observerEmail"
                            v-slot="{ invalid }"
                            tag="form"
                            @submit.prevent="submitEmail()"
                            class="form-container"
        >
          <uni-input-container label="Adresse e-mail" for="email">
            <uni-input rules="required|email|emailExists"
                       v-model="family.email"
                       id="email"
                       type="email"
                       mode="eager"
            />
          </uni-input-container>
          <uni-input-container label="Date de naissance" for="birth-date">
            <uni-input
                v-model="user.birth_date"
                id="birth-date"
                type="date"
            />
          </uni-input-container>
          <uni-button class="full-width">Créer mon compte</uni-button>
        </ValidationObserver>
        <div class="center">
          <p>Vous possédez déjà un compte ?</p>
          <router-link class="uni-link"
                       to="/connexion"
          >
            Me connecter
          </router-link>
        </div>
      </section>
      <section class="section-container" v-show="actualSection.name === 'data'">
        <div class="charte">
          <h3>CHARTE DE FONCTIONNEMENT DE
            RICH’EN DANSE</h3>
          <p>
            Vous venez d’inscrire votre enfant ou de vous inscrire. Nous vous remercions de votre
            confiance et
            voulons
            attirer votre attention sur notre règlement intérieur.
          </p>
          <h3>1. INSCRIPTION</h3>
          <p>
            Les inscriptions se font uniquement sur notre site internet. Vous devez créer un compte pour y
            inscrire vos enfants et/ou vous et remplir l’ensemble des renseignements demandés. Un numéro de
            téléphone et une adresse mail CORRECTEMENT rédigés et valides sont à communiquer
            obligatoirement pour pouvoir prévenir en cas d’accident ou d’annulation de cours, ainsi que pour
            toute information utile tout au long de l’année. Ces données resteront confidentielles, l’association
            s’engage à ne pas les divulguer sans votre accord. Par ailleurs, un questionnaire de santé, complété le
            cas échéant par un certificat médical de non contre-indication, est obligatoire et à fournir
            impérativement au moment de l’inscription. Celui-ci pourra être fourni sous forme numérique via
            votre compte RICH’EN DANSE et devra être téléversé à votre dossier une fois complété et signé.
            Aucune inscription ne pourra être remise au professeur de danse. Une semaine de permanences sera
            prévue durant laquelle vous pourrez procéder au règlement de votre année de cours de danse.</p>
          <p>Au terme des inscriptions, l’association se réserve le droit de refuser votre dossier si celui-ci est
            incomplet (certificat médical manquant le cas échéant, absence de règlement des frais d’inscription).</p>

          <h3>2. RÈGLEMENT</h3>

          <p>L’inscription aux cours de danses de l’association engage financièrement l’élève pour l’année. Tout
            trimestre de cours entamé est dû.</p>

          <p>
            Modes de règlement :
            <ul>
              <li>
                <b>Par chèque</b>, à l’ordre de RICH’EN DANSE pour l’année ou par trimestre. Dans ce dernier cas,
                prévoir 3 chèques à remettre lors des permanences : le 1 er règlement (1 er trimestre +
                cotisation) sera encaissé courant octobre, le 2 nd règlement (2 ème trimestre) sera encaissé
                courant janvier et le 3 ème règlement (3 ème trimestre) sera encaissé courant avril ;
              </li>
              <li>
                <b>Par virement bancaire</b>, pour l’année uniquement ;
              </li>
              <li>
                <b>Par espèces,</b> pour l'année uniquement.
              </li>
            </ul>
          </p>
          <p>
            À noter qu’un règlement pour l’année donne droit à une réduction des frais d’inscription. Par ailleurs,
            tout défaut de règlement pourra entrainer l’exclusion de l’élève le temps que la situation soit
            régularisée.
          </p>

          <h3>3. ASSURANCE</h3>
          <p>
            Conformément à la réglementation en vigueur, l’association est couverte par une assurance
            « Responsabilité civile ». Nous attirons votre attention sur la nécessité de vérifier que votre propre
            assurance vous couvre vous et/ou vos enfants pour la pratique de la danse.
          </p>
          <h3>4. PERTES OU VOL</h3>
          <p>
            Les effets personnels sont laissés à la seule surveillance de l’élève. Le corps professoral et le Comité
            de l’association déclinent toute responsabilité en cas de pertes ou de vols d’objets ou vêtements
            dans les vestiaires, les salles de cours ou lors des galas annuels.
          </p>
          <h3>5. TENUE & PRÉSENTATION</h3>
          <p>
            Pour le confort de tous et le bon déroulement des cours, les élèves acceptent de se conformer au
            port d’une tenue adaptée à chaque pratique de danse.
          </p>
          <p>
            <b>Pour les cours de Classique :</b>
          </p>
          <ul>
            <li>
              Justaucorps
            </li>
            <li>
              Collants
            </li>
            <li>
              Chaussons de danse propres
            </li>
            <li>
              Cheveux attachés ou chignons
            </li>
          </ul>
          <p>
            Pour les cours de modern’ Jazz :
          </p>
          <ul>
            <li>
              cheveux attachés
            </li>
            <li>
              Tenue décontractée
            </li>
            <li>
              chaussures de danse propres ou chaussettes
            </li>
          </ul>
          <p>
            Pour le DanceHall :
          </p>
          <ul>
            <li>
              Baskets propres
            </li>
            <li>
              Tenue décontractée
            </li>

          </ul>
          <p>Pour les cours de Hip-Hop :</p>
          <ul>
            <li>
              Baskets propres
            </li>
            <li>
              cheveux attachés
            </li>
            <li>
              tenue de sport
            </li>
          </ul>
          <p>Pour les cours de Lady Style :</p>
          <ul>
            <li>Tenue décontractée</li>
            <li>Chaussures de dans à talons propres</li>
          </ul>
          <p>
            Tout élève ne respectant pas la tenue demandée ne sera pas admis en cours (ex :
            jean’s).
          </p>
          <h3>6 .ASSIDUITE</h3>


          <p>
            L’élève doit assister régulièrement aux cours et en respecter strictement les horaires. Pour les élèves
            mineurs, les parents doivent s’assurer de la présence du professeur dans les locaux avant de laisser
            l’enfant dans les vestiaires. Par ailleurs, toute absence doit être excusée.
          </p>
          <h3>
            7 .DISCIPLINE
          </h3>
          <p>
            Tout élève doit respecter son professeur, ses consignes ainsi que les autres membres du groupe. Le
            chewing-gum est interdit pendant les cours et l’utilisation du téléphone portable pendant les cours
            ou les répétitions de spectacle n’est pas autorisée.
          </p>
          <p>
            Les élèves doivent être calmes dans les vestiaires et le hall d’accueil pour ne pas perturber le cours
            dispensé dans la salle de danse. Les parents ne sont pas admis dans les vestiaires. Ils sont invités à
            attendre les enfants dans le hall d’accueil ou à l’extérieur du bâtiment dès la fin du cours afin de ne
            pas perturber le bon déroulement du cours suivant.
          </p>
          <h3>
            8. GALA ANNUEL ET REPRÉSENTATIONS
          </h3>
          <p>
            Un gala de fin d’année est traditionnellement organisé au mois de juillet, à la fin de l’année scolaire.
            Il est préparé au cours de l’année, et se déroule comme suit :
            <ul>
              <li>Répétition générale la veille du 1er soir de spectacle,</li>
              <li>Deux soirées de représentation.</li>
            </ul>
          </p>
          <p>
            La présence de l’élève est obligatoire, toutefois l’absentéisme répété et non-justifié au cours de
            l’année, son mauvais comportement et/ou le non-paiement des frais d’inscription pourront donner
            droit au professeur et au Comité de ne pas le faire participer au spectacle.
          </p>
          <p>
            Afin de couvrir les frais du spectacle (location de la salle, matériels et prestations techniques),
            l’association sera amenée à demander une participation financière à chaque spectateur (y compris
            pour les parents d’élèves). Par ailleurs, une caution pourra être demandée pour les costumes mis à la
            disposition des élèves. L’association se réserve le droit d’encaisser la caution en cas de restitution de
            costumes déchirés ou en mauvais état.
          </p>
          <p>
            Lors de ses représentations, l’association peut être amenée à réaliser des photographies et des films.
            Les élèves et parents d’élèves acceptent que ces photos et films soient exploités par l’association à
            des fins de promotion sur ses réseaux sociaux, son site internet voire dans la presse locale. En
            l’absence de consentement, l’association se verra dans l’obligation de refuser la participation de
            l’élève aux différents spectacles.
          </p>
          <p>
            Enfin, l’organisation du Gala annuel est conditionnée à la présence suffisante de bénévoles pour
            assurer le bon déroulement des représentations, essentiellement dans l’encadrement des groupes
            d’élèves mineurs. À cet effet, l’association pourra être amenée à solliciter les parents d’élèves qui le
            souhaitent à occuper un poste bénévole sur l’un des deux soirs de spectacle. En cas d’effectif
            bénévole insuffisant, le Comité se réservera le droit d’annuler l’organisation du spectacle.
          </p>
          <p>
            Le Comité de l’association RICH’EN DANSE, en complémentarité avec le corps professoral, se tient à
            votre entière disposition pour toute difficulté que vous pourrez rencontrer en cours d’année.
          </p>
        </div>
        <ValidationObserver ref="observerData"
                            v-slot="{ invalid }"
                            tag="form"
                            @submit.prevent="submitData()"
                            class="form-container"
        >
          <ValidationProvider rules="required">
            <uni-input-checkbox label="J’ai lu et j’accepte le fonctionnement de la charte Rich’en Danse"
                                id="charte"
            >
              <input type="checkbox"
                     id="charte"
                     value="charte"
                     v-model="user.has_consent_rules"
              >
            </uni-input-checkbox>
          </ValidationProvider>
          <ValidationProvider rules="required">
            <uni-input-checkbox
                label="Je consens à ce que Rich’en Danse collecte et utilise les données personnelles que partagerais avec l'association."
                id="dataCollect"
            >
              <input type="checkbox"
                     id="dataCollect"
                     value="dataCollect"
                     v-model="user.has_consent_data_collect"
              >
            </uni-input-checkbox>
          </ValidationProvider>
          <uni-button class="full-width">Suivant</uni-button>
        </ValidationObserver>
      </section>
      <section class="section-container" v-show="actualSection.name === 'infos'">
        <ValidationObserver ref="observerInfos"
                            v-slot="{ invalid }"
                            tag="form"
                            @submit.prevent="submitInfos()"
                            class="form-container"
        >
          <uni-input-container label="Prénom" for="firstname">
            <uni-input rules="alpha_dash|required"
                       v-model="user.firstname"
                       id="firstname"
            />
          </uni-input-container>

          <uni-input-container label="Nom">
            <uni-input rules="alpha_dash|required"
                       v-model="user.name"
                       id="name"
            />
          </uni-input-container>

          <uni-input-container label="Adresse" for="street">
            <uni-input rules="required"
                       v-model="user.street"
                       id="street"
            />
          </uni-input-container>

          <uni-input-container label="Code postal"
                               for="postalCode">
            <uni-input rules="required|digits:5"
                       v-model="user.postal_code"
                       id="postalCode"
                       mode="eager"
            />
          </uni-input-container>

          <uni-input-container label="Ville" for="city">
            <uni-input rules="required"
                       v-model="user.city"
                       id="city"
            />
          </uni-input-container>
          <uni-input-container label="Téléphone"
                               for="tel"
          >
            <uni-input rules="required|digits:10"
                       v-model="user.tel"
                       id="tel"
            />
          </uni-input-container>

          <rich-yes-no-input question="Êtes vous danseur ?"
                             name="isDancer"
                             v-model="user.is_dancer"
          />
          <rich-yes-no-input question="Autorisez vous le droit à l'image"
                             name="imageRight"
                             v-model="user.is_image_allowed"
                             message="Si vous cochez « Non », vous ne pourrez pas participer au spectacle de fin d’année"
                             v-if="user.is_dancer"
          />
          <uni-button class="full-width">Suivant</uni-button>
        </ValidationObserver>
      </section>

      <section class="section-container" v-show="actualSection.name === 'password'">
        <ValidationObserver ref="observerPassword"
                            v-slot="{ invalid }"
                            tag="form"
                            @submit.prevent="submitPassword()"
                            class="form-container">
          <ValidationProvider
              name="password"
              rules="required|passwordCheck"
              v-slot="{ errors }"
          >
            <uni-input-container label="Mot de passe" id="password">
              <uni-input-password v-model="family.password" id="password"/>
            </uni-input-container>
            <span class="message-error">{{ errors[0] }}</span>
          </ValidationProvider>

          <ValidationProvider
              rules="required|confirmed:password"
              v-slot="{ errors }"
          >
            <uni-input-container label="Confirmez le mot de passe" id="confirm">
              <uni-input-password v-model="family.password_confirmation" id="confirm"/>
            </uni-input-container>
            <span class="message-error">{{ errors[0] }}</span>

          </ValidationProvider>
          <div class="card">
            <p>
              Votre mot de passe doit contenir au minimum
            </p>
            <ul style="list-style: unset">
              <li>
                8 caractères
              </li>
              <li>
                une majuscule
              </li>
              <li>
                un chiffre
              </li>
            </ul>
          </div>
          <uni-loading-button :is-disable="loading" class="full-width" text="Créer le compte"/>
        </ValidationObserver>

      </section>
    </div>
  </div>
</template>

<script>
import UniInput from "../../components/a-elements/UniInput";
import UniInputContainer from "../../components/a-elements/UniInputContainer";
import UniInputCheckbox from "../../components/a-elements/UniInputCheckbox";
import UniInputDate from "../../components/a-elements/UniInputDate";
import UniButton from "../../components/a-elements/UniButton";
import RichLogo from "../../components/a-elements/RichLogo";
import RichRegistrationHeader from "../../components/c-blocks/RichRegistrationHeader";
import RichYesNoInput from "../../components/a-elements/RichYesNoInput";
import UniInputPassword from "../../components/a-elements/UniInputPassword";
import InputBirthday from "../../components/a-elements/InputBirthday";
import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";

export default {
  name: "new",
  components: {
    UniLoadingButton,
    InputBirthday,
    UniInputPassword,
    RichYesNoInput,
    RichRegistrationHeader,
    RichLogo, UniButton, UniInputDate, UniInputCheckbox, UniInputContainer, UniInput
  },
  data() {
    return {
      actualSection: {
        name: 'email',
        title: 'Adresse e-mail',
        id: 1
      },
      family: {
        email: '',
        password: '',
        password_confirmation: ''
      },
      user: {
        name: "",
        firstname: "",
        email: "",
        tel: "",
        is_dancer: null,
        birth_date: null,
        is_image_allowed: null,
        street: "",
        postal_code: "",
        city: "",
        isMinor: false,
        resps: [],
        has_consent_rules: null,
        has_consent_data_collect: null,
      },
      loading: false
    }
  },
  methods: {
    async submitEmail() {
      const isValid = await this.$refs.observerEmail.validate();
      if (!isValid) {
        // ABORT!!
        console.log('Form is uncomplete')
      } else {
        this.actualSection.name = 'data'
        this.actualSection.title = 'Charte et données personelles'
        this.actualSection.id = 2
      }
    },
    async submitData() {
      const isValid = await this.$refs.observerData.validate();
      if (!isValid) {
        // ABORT!!
        console.log('Form is uncomplete')
      } else {
        this.actualSection.name = 'infos'
        this.actualSection.title = 'Informations personnelles'
        this.actualSection.id = 3
        window.scrollTo(0, 0)
      }
    },
    async submitInfos() {
      const isValid = await this.$refs.observerData.validate();
      if (!isValid) {
        // ABORT!!
        console.log('Form is uncomplete')
      } else {
        this.actualSection.name = 'password'
        this.actualSection.title = 'Mot de passe'
        this.actualSection.id = 4
      }
    },
    async submitPassword() {
      this.loading = true
      const isValid = await this.$refs.observerData.validate();
      if (!isValid) {
        // ABORT!!
        console.log('Form is uncomplete')
      } else {
        let obj = {
          users_attributes: {
            0: {
              ...this.user,
              email: this.family.email
            }
          }
        }
        let family = {
          ...this.family,
          ...obj
        }
        this.$registerNewFamily(family)
            .then(data => {
              this.$router.push({name: 'RegistrationSuccess'})
            })
            .catch(err => {
              console.log('erreur serveur :/')
            })
      }
    },
    checkCurrentLogin() {
      if (localStorage.token) {
        this.router.push('/')
      }
    }
  },
  created() {
    this.checkCurrentLogin()
  }
}
</script>

<style scoped lang="scss">
.main {
  padding-top: 16px !important;
  width: 100%;
}

.section-container {
  padding: 0 8px;
}

.section-subtitle {
  margin-bottom: 16px !important;
}

h1 {
  margin-bottom: 24px;
}

.main-title {
  margin-top: 84px;
}

.charte {
  ul {
    list-style: unset;
  }

  h3 {
    margin-bottom: 8px;
  }
}

section {
  margin-bottom: 24px !important;
}

.card {
  margin-bottom: 24px;
}

@include screen-xs {
  .button-password {
    left: 16px;
    bottom: 16px;
    width: calc(100% - 32px);
  }
  .section-container {
    padding: 0 16px;
  }
}

@include screen-l {
  .app-name {
    margin: 24px 24px 72px 24px;
  }
  .full-width {
    width: 100%;
  }
  .section-container {
    margin: 0 auto;
    max-width: 482px;
  }
  .main-title {
    margin-top: 72px;
  }
}
</style>
